import { t } from '@citrite/translate';
import { LeftNavPositions } from '@citrite/workspace-ui-platform';
import { Home } from 'App/Home/Home';
import { HomeIcon, HomeSelectedIcon } from 'App/Home/HomeIcons';
import { homePagePath } from 'Router/homePageRoute';
import { createLeftNavRoute } from 'Router/ReactRoute';
import { checkHomeAvailability } from '../Navigation/checkHomeAvailability';

export const homeRoute = createLeftNavRoute({
	component: Home,
	path: homePagePath,
	isAvailable: props => checkHomeAvailability(props),
	isLoading: props => !props.userContext.isIWSEnabled && props.resources.loading,
	getNavLinkProps: () => ({
		title: t('Workspace:home'),
		icon: HomeIcon,
		selectedIcon: HomeSelectedIcon,
		weight: LeftNavPositions.dashboard,
		analyticsID: 'home-nav-tab',
	}),
	pathParams: {},
});
